import type { ReactNode } from "react";

import { StepCard, type CardTone } from "./StepCard";

export type { CardTone };

export type Headline = { text: string; target?: string; tail?: string };

type Props = {
  tone: CardTone;
  headline: Headline;
  from: { store: string; field: string };
  to: { label: string; path: string } | null;
  usedBy: ReactNode;
  afterHeadline?: ReactNode;
  children?: ReactNode;
};

export function DecisionCard({
  tone,
  headline,
  from,
  to,
  usedBy,
  afterHeadline,
  children,
}: Props) {
  return (
    <StepCard tone={tone}>
      <h4 className="font-heading text-[19px] font-normal leading-[1.35] text-slate-900 dark:text-slate-50">
        {headline.text}
        {headline.target && (
          <span className="text-indigo-700 dark:text-indigo-200">
            {headline.target}
          </span>
        )}
        {headline.tail}
      </h4>
      {afterHeadline}
      {to && (
        <p className="flex flex-wrap items-center gap-2 text-[13px]">
          <span className="text-slate-500 dark:text-slate-400">
            {from.store}
          </span>
          <span className="font-semibold text-slate-900 dark:text-slate-50">
            {from.field}
          </span>
          <span aria-hidden className="text-indigo-500 dark:text-indigo-400">
            →
          </span>
          <span className="font-semibold text-slate-900 dark:text-slate-50">
            {to.label}
          </span>
          <span className="break-all font-mono text-xs text-slate-500 dark:text-slate-400">
            {to.path}
          </span>
        </p>
      )}
      {usedBy}
      {children}
    </StepCard>
  );
}
